import { defineMessages } from 'react-intl';

// design: music24-demo-artist a1-a5.
export const demoArtistMessages = defineMessages({
  tag: { id: 'app.sml.demoArtist.tag', defaultMessage: 'Example' },
  notice: {
    id: 'app.sml.demoArtist.notice',
    defaultMessage: 'You are viewing <b>{name}</b>, an example artist. The data is not real and you cannot change it.',
  },
  switchToOwn: { id: 'app.sml.demoArtist.switchToOwn', defaultMessage: 'Switch to my artist' },
  dismiss: { id: 'app.sml.demoArtist.dismiss', defaultMessage: 'Hide this notice' },
  settingsReadOnly: {
    id: 'app.sml.demoArtist.settingsReadOnly',
    defaultMessage: 'This is an example artist. You cannot change its name or its picture.',
  },
});
